import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';
import { ReturnResonsComponent } from '../return-resons/return-resons.component';

@Component({
  selector: 'app-make-return',
  templateUrl: './make-return.component.html',
  styleUrls: ['./make-return.component.scss'],
})
export class MakeReturnComponent implements OnInit {
  @Input() order_id;
  @Input() items;

  return_details;
  return_products;
  // return_products_items = [];
  qty;
  currentDate

  constructor(public modalCtrl:ModalController,public formBuilder:FormBuilder,public db: DataService) { }

  ngOnInit() {
    this.get_reason_return();
    this.get_retuen_products(); 

  }



  get_retuen_products(){
    let data ={
      order_id : this.order_id
    }
    this.db.get_return_request_info(data).subscribe(res=>{
       if(res.message){
        res.message.order_item.map(res =>{
          res.count = 0;
        })
       }
       this.return_products = res.message;
      //  console.log("REC",this.items);
      //  this.items.order_item.map(res =>{
      //     res.count = 0
      // })
      // this.return_products_items = this.items;
      // console.log(this.items);
       
      //  this.return_products.order_date = this.checck_order_date(this.return_products.order_date)
      //  console.log("REC",this.return_products.order_date);
  //  if(this.db.website_settings.return_based_on == "Delivery Date"){
  //    (this.return_products.order_item).map(r=>{
  //     r.delivery_date = this.check_delivery_date(r.delivery_date);
  //    })
  //   }else{
      
  //   }

      // this.get_recommeded();
    })
  }

  get_reason_return(){
    this.db.get_return_request_details().subscribe(r=>{
      // console.log("RESPONSE",r);
      this.return_details = r.message
    })
    }


    add(value){
      // console.log(value)
      if(value.count < value.quantity){
        value.count = value.count + 1;
        this.qty = true;
      }
    }
  
    remove(value){
      // console.log(value)
      if(value.quantity >= 0){
        value.count = value.count - 1;
        this.qty = true;
     }
    }
    dismiss(){
      this.modalCtrl.dismiss();
    }

    async return(product){
      if(product.count == 0){
        this.db.alert('Please select any product by changing its quantity')
      }else {
        // console.log('product',product);
        let products=[{"item":product.item,"quantity":product.count,"price":product.price,"amount":product.amount}]
        this.modalCtrl.dismiss();
        const modal = await this.modalCtrl.create({
          component: ReturnResonsComponent,
          cssClass:  '',
          componentProps: {  
            return_details : this.return_details,
            order_id : this.order_id,
            product_id : products
          }
        })
        // this.db.modal = true;
        await modal.present();
        let data = await modal.onWillDismiss();
        // if(data){
        //   this.db.modal = false;
        // }
       }
     }

}
